import accountService from '@d-services/account-service/account-service';
import URLS from '@d-shared/urls/urls';
import Window from '@d-shared/utils/window';

export default class AccountHelper {
  static async logOut() {
    try {
      await accountService.logOut();
    } catch (error) {
      // 401 Unauthorized - Already logged out
      if (error.response && error.response.status !== 401) {
        throw error;
      }
    }

    Window.goTo(URLS.app.home);
  }
}
